import type { SessionFormat } from '../types/auth';

/**
 * CORE-1860 (решение владельца 30.10.2026, QA FAIL 30.10 №3) — в формате «Соло»
 * участники не включают микрофон: «Вы ведёте сессию один. Участники слушают и
 * не могут включить микрофон». Сервер держит это сам (`SoloMicsPolicy`,
 * `areMicsAllowed=false`); клиент не предлагает того, что сервер не примет.
 */
export const isSoloFormat = (format: SessionFormat | null | undefined): boolean => format === 'solo';

/**
 * Можно ли ведущему нажать «Можно включать микрофон». В «Соло» — только чтобы
 * выключить разрешение, оставшееся с сессии до этого решения.
 */
export const canToggleMicsAllowed = (input: {
    canModerateAudio: boolean;
    format: SessionFormat | null | undefined;
    micsAllowed: boolean;
}): boolean => input.canModerateAudio && (!isSoloFormat(input.format) || input.micsAllowed);
